import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../../session/useFetchWithAuth'

const API_URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface AdminSchool {
  id: string
  name: string
  district: string
  city: string
}

export const useAdminSchools = () => {
  const fetchWithAuth = useFetchWithAuth()

  const getSchools: QueryFunction<AdminSchool[]> = async () => {
    try {
      const responseData = await fetchWithAuth(`${API_URL}/admin/schools`, {
        method: 'GET',
      })
      return responseData
    } catch (error) {
      console.error('Error fetching admin schools:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['adminSchools'] as const,
    queryFn: getSchools,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useAdminSchool = (id?: string) => {
  const fetchWithAuth = useFetchWithAuth()

  const getSchool: QueryFunction<AdminSchool> = async () => {
    if (!id) {
      throw new Error('School ID is required')
    }

    try {
      const responseData = await fetchWithAuth(
        `${API_URL}/admin/schools/${id}`,
        {
          method: 'GET',
        }
      )
      return responseData
    } catch (error) {
      console.error('Error fetching admin school:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['adminSchool', id] as const,
    queryFn: getSchool,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: !!id && id.length > 0,
  })
}
